import { CheckIcon } from '@chakra-ui/icons'
import { Avatar, HStack, MenuItem, Text } from '@chakra-ui/react'
import { Token, Width } from 'types/chakra'
import { IAsyncSelectOptionWithIcon } from 'interfaces/common'
import IconBuilder from 'pages/IconBuilderPage/components/IconBuilder'
import { DARK_CARD_SELECTED_BORDER, DARK_TEXT_PRIMARY, DARK_TEXT_MUTED } from 'constants/dark-tokens'

interface IDropdownSelectionProps {
  item: IAsyncSelectOptionWithIcon<number>
  onClick: () => void
  isSelected?: boolean
  height?: Token<Width | number, 'sizes'>
  minWidth?: Token<Width | number, 'sizes'>
  maxWidth?: Token<Width | number, 'sizes'>
  /** When true applies dark surface palette — leave false (default) for light contexts */
  dark?: boolean
}

const DropdownSelection = (props: IDropdownSelectionProps) => {
  const { item, onClick, isSelected, minWidth, maxWidth, dark = false } = props

  const itemBg = dark
    ? isSelected ? 'rgba(255,255,255,0.12)' : 'transparent'
    : isSelected ? 'primary.100' : 'white'

  const itemHover = dark ? { background: 'rgba(255,255,255,0.08)' } : { background: 'primary.100' }
  const itemColor = dark ? (isSelected ? DARK_TEXT_PRIMARY : DARK_TEXT_MUTED) : 'gray.700'
  const checkColor = dark ? DARK_CARD_SELECTED_BORDER : 'primary.500'

  return (
    <MenuItem
      padding="6px 12px"
      minWidth={minWidth}
      maxWidth={maxWidth}
      onClick={onClick}
      className="dropdown-selection"
      background={itemBg}
      _hover={itemHover}
      _focus={itemHover}
      _active={itemHover}
      borderWidth="0"
      outline="none"
      height="44px"
      color={itemColor}
      fontSize={{ base: 'md', lg: 'sm' }}
      justifyContent={{ base: 'center', md: 'flex-start' }}
    >
      <HStack width="full" spacing={6}>
        <HStack width="full">
          {item?.icon && <IconBuilder icon={item?.icon} size={32} isActive />}
          {(item?.image || item?.image === '') && <Avatar size="xs" name={item.label} src={item.image} />}
          {/* One line, ellipsised: a long member name used to wrap and get clipped
              by the menu's fixed height. */}
          <Text color={itemColor} noOfLines={1} whiteSpace="nowrap" textOverflow="ellipsis" overflow="hidden">
            {item?.label ?? ''}
          </Text>
        </HStack>
        <CheckIcon display={isSelected ? 'block' : 'none'} color={checkColor} />
      </HStack>
    </MenuItem>
  )
}

export default DropdownSelection
